import {useQcAccuracy, useQcVerticalAccuracy} from '@/api/hooks';
import {
  type AccuracyOutcome,
  ReviewAccuracySummary
} from '@/components/shared/ReviewAccuracySummary';

// Only approved-as-is is accurate: an edit means QC had to correct the call, as a rejection does.
const OUTCOMES: AccuracyOutcome[] = [
  {field: 'approved', label: 'Approved'},
  {field: 'approved_with_edits', label: 'Approved with edits', error: true},
  {field: 'rejected', label: 'Rejected', error: true}
];

export function QcAccuracySummary() {
  return (
    <ReviewAccuracySummary
      idPrefix="qc-accuracy"
      outcomes={OUTCOMES}
      useVerticalRows={useQcVerticalAccuracy}
      useAnalystRows={useQcAccuracy}
    />
  );
}
